import { connect } from 'react-redux'
import { getMessagesTranslator } from '@layers-frontend/commons/store/selectors/messages'
import { getUserId, hasRoleIrriga } from '@layers-frontend/commons/store/selectors/user'
import { canUseLayi } from '../selectors/users'
import { openLayiNotificationsModal } from '../actions/modal'
import LayiNotificationsInvite from '../components/ChatbotWidget/LayiNotificationsInvite'

// Gated on ROLE_WEB_LAYI like every part of LAYI. The per-user check still runs for everyone: without the role,
// or with ROLE_IRRIGA, it removes the opt-in and keeps the user's record.
const mapStateToProps = state => ({
  canUseLayi: canUseLayi(state),
  userId: getUserId(state),
  hasRoleIrriga: hasRoleIrriga(state),
  t: getMessagesTranslator(state)
})

const mapDispatchToProps = {
  openLayiNotificationsModal
}

export default connect(mapStateToProps, mapDispatchToProps)(LayiNotificationsInvite)
